<template>
  <div class="OJProblemManagement">
    <div>
      <div style="font-size: 14px;">
        <div style="position: relative;font-size: 14px;">
          <el-image style="width: 100%;border-radius: 20px;margin-top:40px;"
            src="https://wugecdn.steam.fun/resources/static/oj/rank.png" fit="fill">
          </el-image>
        </div>
      </div>

      <div style="text-align: center;margin-top:20px;">
        <span style="height: 64px;line-height: 64px;">
          <svg style="margin-top:15px;" t="1658478029899" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="9697" width="34" height="34">
            <path d="M448.8 622.8h126.5v126.5H448.8z" fill="#FFB300" p-id="9698"></path>
            <path d="M609.7 796.8H414.3v-61.2c0-11.5 9.4-20.9 20.9-20.9h153.7c11.5 0 20.9 9.4 20.9 20.9v61.2z"
              fill="#FFCA28" p-id="9699"></path>
            <path
              d="M708.1 1016.2H315.9c-11.5 0-20.9-9.4-20.9-20.9V817.2c0-11.5 9.4-20.9 20.9-20.9h392.3c11.5 0 20.9 9.4 20.9 20.9v178.1c-0.1 11.6-9.4 20.9-21 20.9z"
              fill="#455A64" p-id="9700"></path>
            <path
              d="M638.3 964H385.7c-5.8 0-10.4-4.7-10.4-10.4V852.7c0-5.8 4.7-10.4 10.4-10.4h252.6c5.8 0 10.4 4.7 10.4 10.4v100.8c0 5.8-4.6 10.5-10.4 10.5z"
              fill="#CFD8DC" p-id="9701"></path>
            <path
              d="M257.2 115.8v284.8c-83.8-11.7-148.5-83.8-148.5-170.8v-114h148.5m52.2-52.2H98.2c-23.1 0-41.8 18.7-41.8 41.8v124.5C56.4 354 157 454.6 281.1 454.6h28.3v-391zM915.3 115.8v108.8c0 88-64.4 161.3-148.5 175.2v-284h148.5m10.5-52.2H714.6v390.9h23.1c126.9 0 229.8-102.9 229.8-229.8V105.4c0.1-23.1-18.7-41.8-41.7-41.8z"
              fill="#FFB300" p-id="9702"></path>
            <path
              d="M512 647.9c-162.7 0-294.6-131.9-294.6-294.6V27.6c0-10.9 8.9-19.8 19.8-19.8h549.5c10.9 0 19.8 8.9 19.8 19.8v325.7C806.6 516 674.7 647.9 512 647.9z"
              fill="#FFCA28" p-id="9703"></path>
            <path
              d="M787.3 458.4L640.1 265 433.6 413l167 221.4c43.9-14.5 74.6-33.9 103.9-58.3 34.9-29.1 62.9-67.8 82.8-117.7z"
              fill="#FFB806" p-id="9704"></path>
            <path
              d="M522.3 178.3l31.3 63.3c1.5 3.1 4.5 5.2 7.9 5.7l69.9 10.2c8.6 1.2 12 11.8 5.8 17.8l-50.6 49.3c-2.5 2.4-3.6 5.9-3 9.2l11.9 69.6c1.5 8.5-7.5 15-15.2 11L512.9 379l-67.4 35.4c-7.7 4-16.6-2.5-15.2-11l11.9-69.6c0.6-3.4-0.5-6.8-3-9.2l-50.6-49.3c-6.2-6-2.8-16.6 5.8-17.8l69.9-10.2c3.4-0.5 6.3-2.6 7.9-5.7l31.3-63.3c3.9-7.8 15-7.8 18.8 0z"
              fill="#FFF8E1" p-id="9705"></path>
          </svg>
        </span>
        <span
          style="display: inline; height: 64px;line-height: 64px; vertical-align: top; color:white;font-size: 34px;font-weight: bold;margin-left:10px;">{{
            contestInfo.title }}</span>
      </div>
      <div style="text-align: right;">
        <span style="margin-right: 10px;"><el-button size="mini" @click="handleExport">导出excel</el-button></span>
        <span style="color:white;font-weight: bold;font-size: 16px;">主办单位:</span><span
          style="font-size: 16px;color:#f7cc4f;font-weight: bold; margin-left:10px;">{{ contestInfo.sponsor }} </span>

        <span style="float:left;">
          <span v-if="isShowTime" style="text-align: center;"><span v-if="isShowEndTime"><span
                style="color:white;font-weight: bold;font-size: 16px;">距离比赛结束还有:</span>
              <span style="color:rgb(246, 182, 6); font-weight: bold;font-size:20px; margin-left: 10px;">{{
                countdownTime
              }}</span></span></span>
          <span v-else style="text-align: center;"><span>距离比赛开始还有:</span>
            <span style="color:white; font-weight: bold; margin-left: 10px;">{{
              countdownTime1
            }}</span>
          </span>
        </span>
      </div>

      <div class="main">
        <el-table size="small" :data="tableData1" stripe style="width: 100%;border-radius: 5px;"
          :header-cell-style="{ background: '#36364c', color: 'white' }">
          <el-table-column type="index" label="名次"> </el-table-column>
          <el-table-column width="100" label="头像" align="center">
            <template slot-scope="scope">
              <el-image style="width: 30px; height: 30px" :src="scope.row.headImgUrl" fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="realname" label="参赛者" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.stu_user_id === null">{{
                scope.row.realname
              }}</span>
              <span v-else>{{ scope.row.realname }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="" label="通过" v-if="contestInfo.rule_type === 1 ? true : false">
            <template slot-scope="scope">
              <span>{{ scope.row.ac_problem_num }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="" :label="contestInfo.rule_type === 1 ? '耗时' : '总分'">
            <template slot-scope="scope">
              <span v-if="contestInfo.rule_type === 1">
                <el-tooltip placement="top">
                  <div slot="content">
                    {{ goTime(scope.row.total_cost_time) }}
                  </div>
                  <span style="cursor: pointer;"> {{
                    Math.floor(scope.row.total_cost_time / 60) +
                    ":" +
                    ((scope.row.total_cost_time % 60) / 100)
                      .toFixed(2)
                      .slice(-2)
                  }}</span>
                </el-tooltip>

              </span>
              <span v-else>
                <div>{{ scope.row.score }}</div>
                <div>({{ scope.row.total_cpu_time }})ms</div>
              </span>
            </template>
          </el-table-column>
          <template>
            <el-table-column v-for="(item, index) in tableData" :label="'#' + (index + 1 + '')" :key="index + 1">
              <template slot-scope="scope">
                <span v-for="(item1, index1) in JSON.parse(
                  scope.row.submission_info
                )" :key="index1">
                  <span v-if="item1.problemId === item.oj_problem_id &&
                    contestInfo.rule_type === 1
                    ">
                    <div v-if="item1.result != 0">
                      <div style="color:#f00;font-weight:bold">
                        -{{ item1.beforeRightSubmissionNum }}
                      </div>
                      <div>00:00</div>
                    </div>
                    <div v-else>
                      <div v-if="item1.beforeRightSubmissionNum === 0">
                        <div style="color:#52C41A;font-weight:bold" class="el-icon-check"></div>
                        <div>
                          <el-tooltip placement="top">
                            <div slot="content">
                              {{ goTime(item1.costTime) }}
                            </div>
                            <span style="cursor: pointer;">
                              {{
                                Math.floor(item1.costTime / 60) +
                                ":" +
                                ((item1.costTime % 60) / 100).toFixed(2).slice(-2)
                              }}</span>
                          </el-tooltip>

                        </div>
                      </div>
                      <div v-else>
                        <div style="color:#52C41A;font-weight:bold">
                          +{{ item1.beforeRightSubmissionNum }}
                        </div>
                        <el-tooltip placement="top">
                          <div slot="content">
                            {{ goTime(item1.costTime) }}
                          </div>
                          <span style="cursor: pointer;">
                            {{
                              Math.floor(item1.costTime / 60) +
                              ":" +
                              ((item1.costTime % 60) / 100).toFixed(2).slice(-2)
                            }}</span>
                        </el-tooltip>

                      </div>


                    </div>
                  </span>
                  <span style="color:blue;cursor: pointer;" v-if="item1.problemId === item.oj_problem_id &&
                      contestInfo.rule_type === 2
                      ">
                    <div>{{ item1.score }}</div>
                    <div>{{ item1.cpuTime }}</div>
                  </span>
                  <span v-if="item1.problemId === item.oj_problem_id &&
                    contestInfo.rule_type === 3
                    ">
                    <div style="color:blue;cursor: pointer;">
                      {{ item1.score }}
                    </div>
                    <div>({{ item1.cpuTime }})ms</div>
                  </span>
                </span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <!--
                <div style="margin: 20px; text-align: right">
                    <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1"
                        layout="total, prev, pager, next, jumper" :total="total1">
                    </el-pagination>
                </div>
                -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  // getContestRankList,
  // getProblemForContest,
  // getUserContestRank,
  h5GetContestRankList
} from "@/api/match.js";
import moment from "moment";
import md5 from 'js-md5';
import FileSaver from "file-saver";
import ExcelJS from "exceljs";
require("moment/locale/zh-cn");
export default {
  data() {
    return {
      withStyle: "",
      timer: null,
      timer1: null,
      isShowTime: true,
      isShowEndTime: false,
      page_no: 1,
      page_size: 100,
      total: 0,
      tableData: [],
      tableData1: [],
      tableData2: [],

      page_no1: 1,
      page_size1: 10000,
      total1: 0,
      contentMain: {},
      countdownTime: "",
      countdownTime1: "",
      contestInfo: {},
      md5TXt: '',
      md5TXt1: '',


    };
  },

  mounted() {
    this.md5TXt = md5(this.$route.query.id)
    this.md5TXt1 = md5(this.md5TXt)
    console.log(this.md5TXt, 1245)
    console.log(this.md5TXt1, 1245)
    this.h5GetContestRankList()

    // this.getContestRankList();
    // this.getProblemForContest();
    this.countDown();
    // sessionStorage.setItem("pageNo", 1);
    //this.contentMain = JSON.parse(sessionStorage.getItem("matchDetails"));
    this.search();

  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    this.timer = null;
    this.timer1 = null;
  },
  methods: {
    // handleExport() {
    //   let workbook = new ExcelJS.Workbook();
    //   let worksheet = workbook.addWorksheet('My Worksheet');

    //   worksheet.addRow(['First Line']);
    //   worksheet.addRow(['Second Line']);
    //   worksheet.mergeCells('A1', 'A2');
    //   // 在单元格中设置富文本值

    //   // 保存为Excel文件
    //   workbook.xlsx.writeBuffer().then((buffer) => {
    //     const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     FileSaver.saveAs(data, '比赛排行.xlsx');
    //   });
    // },
    // 下载Excel模板
    handleExport() {
      let listTable = []
      // 创建一个工作簿
      var workbook = new ExcelJS.Workbook();
      // 创建一个工作表
      var worksheet = workbook.addWorksheet('Sheet1');

      this.tableData.map((item, index) => {
        console.log(item)
        console.log(index)
        listTable.push('#' + (index + 1 + ''))
      })
      console.log(listTable, 12345678)
      if (this.contestInfo.rule_type == 1) {
        worksheet.addRow(["名次", "参赛者", "通过", "耗时", ...listTable]);
        this.tableData1.map((item, index) => {
          item.tableContents = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            console.log(match, 12345678999)
            if (match) {
              if (match.result != 0) {
                return match ? '00:00' : '';
              } else {
                if (match.beforeRightSubmissionNum === 0) {
                  return match ? Math.floor(match.costTime / 60) + ":" + ((match.costTime % 60) / 100).toFixed(2).slice(-2) : '';
                } else {
                  return match ? Math.floor(match.costTime / 60) + ":" + ((match.costTime % 60) / 100).toFixed(2).slice(-2) : '';
                }
              }
            } else {
              return ''
            }
          })
          item.tableContents1 = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            console.log(match, 12345678999)
            if (match) {
              if (match.result != 0) {
                return match ? '-' + match.beforeRightSubmissionNum : '';
              } else {
                if (match.beforeRightSubmissionNum === 0) {
                  return match ? '√' : '';
                } else {
                  return match ? '+' + match.beforeRightSubmissionNum : '';
                }
              }
            } else {
              return ''
            }
          })
          worksheet.addRow([index + 1, item.realname, item.ac_problem_num, Math.floor(item.total_cost_time / 60) + ":" + ((item.total_cost_time % 60) / 100).toFixed(2).slice(-2), ...item.tableContents1]);
          worksheet.addRow(['', '', '', '', ...item.tableContents]);

        })
      } else if (this.contestInfo.rule_type == 2) {
        worksheet.addRow(["名次", "参赛者", "总分", ...listTable]);
        // 将数据添加到工作表中
        this.tableData1.map((item, index) => {
          item.tableContents = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            // return match ? match.score + ' ' + match.cpuTime : '';
            return match ? match.score : '';

          })
          item.tableContents1 = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            return match ? '(' + match.cpuTime + ')' + 'ms' : '';
          })
          worksheet.addRow([index + 1, item.realname, item.score, ...item.tableContents]);
          worksheet.addRow(['', '', '(' + item.total_cpu_time + ')' + 'ms', ...item.tableContents1]);

        })
      } else if (this.contestInfo.rule_type == 3) {
        worksheet.addRow(["名次", "参赛者", "总分", ...listTable]);
        // 将数据添加到工作表中
        this.tableData1.map((item, index) => {
          item.tableContents = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            return match ? match.score : '';
          })
          item.tableContents1 = this.tableData.map((item1) => {
            let match = JSON.parse(item.submission_info).find(obj => obj.problemId === item1.oj_problem_id);
            return match ? '(' + match.cpuTime + ')' + 'ms' : '';
          })
          worksheet.addRow([index + 1, item.realname, item.score, ...item.tableContents]);
          worksheet.addRow(['', '', '(' + item.total_cpu_time + ')' + 'ms', ...item.tableContents1]);
        })
      }
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const textLength = cell.value ? cell.value.toString().length : 0;
          if (textLength > maxLength) {
            maxLength = textLength;
          }
        });
        column.width = Math.min(50, Math.max(10, maxLength * 1.2));
      });
      // 自定义样式
      let headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF1878FF" } // 设置颜色代码，
        };
      });
      // worksheet.getRow(1).font = { bold: true };
      worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
        console.log(rowNumber)
        row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
          cell.alignment = { horizontal: 'center' };
          console.log(colNumber)
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      });

      // 生成Excel文件
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(data, this.contestInfo.title + '.xlsx');
      });



    },
    goTime(val) {
      return moment.utc(val * 1000).format('HH:mm:ss')
      // console.log(moment.utc(31618 * 1000).format('HH:mm:ss'), 1245)
      // var timestamp4 = new Date(31618);
      //利用拼接正则等手段转化为yyyy-MM-dd hh:mm:ss 格式
    },

    countDown() {
      let endTime = new Date(this.$route.query.endTime); // 结束时间
      let startTime = new Date(this.$route.query.startTime); // 开始时间
      this.timer = setInterval(() => {
        let nowTime = moment()
          .locale("zh-cn")
          .format("YYYY-MM-DD HH:mm:ss"); //当前时间
        let endTime1 = moment(endTime)
          .locale("zh-cn")
          .format("YYYY-MM-DD HH:mm:ss");
        console.log(endTime1);
        let x = moment(endTime).diff(moment(nowTime), "seconds");
        var d = moment.duration(x, "seconds");
        this.countdownTime =
          Math.floor(d.asDays()) +
          " 天 " +
          d.hours() +
          " 时 " +
          d.minutes() +
          " 分 " +
          d.seconds() +
          " 秒 ";
        let startTime1 = moment(startTime)
          .locale("zh-cn")
          .format("YYYY-MM-DD HH:mm:ss");
        console.log(startTime1);
        let x1 = moment(startTime).diff(moment(nowTime), "seconds");
        var d1 = moment.duration(x1, "seconds");
        this.countdownTime1 =
          Math.floor(d1.asDays()) +
          " 天 " +
          d1.hours() +
          " 时 " +
          d1.minutes() +
          " 分 " +
          d1.seconds() +
          " 秒 ";
        if (x < 0) {
          this.isShowEndTime = false;
          clearInterval(this.timer);
          this.timer = null;
          clearInterval(this.timer1);
          this.timer1 = null;
        } else {
          this.isShowEndTime = true;
        }
        if (x1 < 0) {
          this.isShowTime = true;
          console.log(1254);
        } else {
          this.isShowTime = false;
          console.log(7777777);
          // clearInterval(this.timer1);
          // this.timer1 = null;
        }
      }, 1000);
    },
    search() {
      this.timer1 = setInterval(() => {
        this.h5GetContestRankList()
        // this.page_no1 = sessionStorage.getItem("pageNo");
        // this.getContestRankList();
        // this.getProblemForContest();
      }, 60000);
    },
    h5GetContestRankList() {
      h5GetContestRankList({
        verifyCode: this.md5TXt1,
        contest_id: this.$route.query.id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res, 123456)
        this.contestInfo = res.contestInfo;
        this.tableData1 = res.contestRankList
        this.tableData = res.contestProblemRelationList
      })
    }
    // handleCurrent1(val) {
    //   this.page_no1 = val;
    //   sessionStorage.setItem("pageNo", val);
    //   this.getContestRankList();
    // },
    // getProblemForContest() {
    //   getProblemForContest({
    //     constest_id: this.$route.query.id,
    //     page_no: this.page_no,
    //     page_size: this.page_size,
    //   }).then((res) => {
    //     console.log(res);
    //     this.tableData = res.contestProblemRelationList;
    //     this.total = res.total;
    //     let arr1 = [];
    //     arr1 = res.contestProblemRelationList;
    //     getUserContestRank({
    //       contest_id: this.$route.query.id,
    //     }).then((res) => {
    //       let arr2 = [];
    //       res.contestRankList.map((item1) => {
    //         arr2 = JSON.parse(item1.submission_info);
    //       });
    //       arr1.map((item) => {
    //         arr2.map((item1) => {
    //           if (item1.problemId === item.oj_problem_id) {
    //             item.stats = "1";
    //           }
    //         });
    //       });
    //       console.log(arr1, 123456);
    //     });
    //   });
    // },

    // getContestRankList() {
    //   getContestRankList({
    //     // md5TXt1
    //     verifyCode: this.md5TXt1,
    //     contest_id: this.$route.query.id,
    //     page_no: this.page_no1,
    //     page_size: this.page_size1,
    //   }).then((res) => {
    //     console.log(res, 12456);
    //     this.contestInfo = res.contestInfo;
    //     this.tableData1 = res.contestRankList;
    //     this.total1 = res.total;
    //     this.$nextTick(() => {
    //       console.log(this.$refs.textRef.offsetWidth, 1245);
    //       this.withStyle = this.$refs.textRef.offsetWidth + 40 + "px";
    //       console.log(this.withStyle, 1245);
    //     });
    //   });
    // },
  },
};
</script>
<style lang="scss" scoped>
.OJProblemManagement {
  font-size: 14px;
  background: #1c1e2c;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-left: 20%;
  padding-right: 20%;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
}

.main {
  margin-top: 30px;
  padding: 20px;
  border-radius: 10px;
  background: #282a3c;
  box-sizing: border-box;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}
</style>
